export const CURATIONS_CSV_FILES = [
    'total_sends_count.csv',
    'delivery_rate.csv',
    'unique_open_rate.csv',
    'unique_click_rate.csv',
    'average_audience_size.csv',
    'messages_sent_count.csv',
    'messages_over_time.csv',
    'opens_by_device.csv',
    'clicks_by_device.csv',
    'top_25_links_by_clicks.csv',
    'engagement_by_curation.csv',
    'unique_clicks_by_day_of_week.csv',
    'unique_opens_by_hour_of_day.csv',
    'engagement_funnel.csv',
];

export const CONTACTS_CSV_FILES = [
    'contact_ages.csv',
    'contact_count.csv',
    'contact_locations.csv',
    'contact_domains.csv',
    'contact_subscription_status.csv',
    'contact_gender.csv',
    'subscription_over_time.csv',
    'unsubscription_over_time.csv',
];

export const OVERVIEW_CSV_FILES = [
    'total_sends_count.csv',
    'delivery_rate.csv',
    'unique_open_rate.csv',
    'unique_click_rate.csv',
    'average_audience_size.csv',
    'messages_sent_count.csv',
    'unique_open_rate_over_time.csv',
    'click_through_rate_over_time.csv',
    'click_to_open_rate_over_time.csv',
    'top_10_sends_by_unique_open_rate.csv',
    'top_10_sends_by_unique_click_rate.csv',
];

export const SMS_CSV_FILES = [
    'total_sends_count.csv',
    'delivery_rate.csv',
    'messages_sent_count.csv',
    'average_audience_size.csv',
    'total_subscribers.csv',
    'opt_out_rate.csv',
    'total_sends_over_time.csv',
    'subscription_over_time.csv',
    'unsubscription_over_time.csv',
    'sms_send_metrics.csv',
];

export const VOICE_CSV_FILES = [
    'calls_attempted.csv',
    'call_answered_rate.csv',
    'average_call_duration.csv',
    'send_count.csv',
    'opt_out_rate.csv',
    'sent_to_voicemail.csv',
    'actions_taken.csv',
    'voice_calls_over_time.csv',
    'opt_out_rate_over_time.csv',
    'campaign_performance_metrics.csv',
    'call_duration_density.csv',
    'call_attempted_vs_answered.csv',
];

export const VALUE_CSV_FILES = [
    'audience.csv',
    'conversion_value.csv',
    'forecasted_click_rate.csv',
    'forecasted_events.csv',
    'forecasted_value.csv',
    'estimated_click_rate.csv',
    'estimated_events.csv',
    'estimated_value.csv',
    'actual_click_rate.csv',
    'actual_events.csv',
    'actual_value.csv',
    'events.csv',
    'values.csv',
    'value_summary_by_curation.csv',
    'unique_clicks_by_days_from_send.csv',
];
